import React, { useState } from "react";

/** Every node id in a tree (for Expand all). */
export const allIds = (nodes = []) =>
  nodes.flatMap((n) => [n.id, ...allIds(n.children || [])]);

const Node = ({ node, depth, open, toggle, renderNode, isInactive }) => {
  const kids = node.children || [];
  const isOpen = open.has(node.id);
  return (
    <li>
      <div className={`org-node ${isInactive?.(node) ? "is-inactive" : ""}`}>
        {kids.length ? (
          <button
            type="button"
            className="org-toggle"
            onClick={() => toggle(node.id)}
            aria-expanded={isOpen}
            aria-label={`${isOpen ? "Collapse" : "Expand"}`}
          >
            <i className={`bi bi-chevron-${isOpen ? "down" : "right"}`}></i>
          </button>
        ) : (
          <span className="org-toggle-spacer" aria-hidden="true"></span>
        )}
        {renderNode(node, depth)}
      </div>
      {kids.length > 0 && isOpen && (
        <ul>
          {kids.map((k) => (
            <Node
              key={k.id}
              node={k}
              depth={depth + 1}
              open={open}
              toggle={toggle}
              renderNode={renderNode}
              isInactive={isInactive}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

/**
 * Expandable tree of { id, children } nodes. The first `openDepth` levels
 * start open. renderNode(node, depth) draws one row.
 */
const OrgTree = ({ nodes = [], renderNode, isInactive, openDepth = 1 }) => {
  const [open, setOpen] = useState(() => {
    const ids = new Set();
    const walk = (list, d) =>
      list.forEach((n) => {
        if (d >= openDepth) return;
        ids.add(n.id);
        walk(n.children || [], d + 1);
      });
    walk(nodes, 0);
    return ids;
  });
  const toggle = (id) =>
    setOpen((s) => {
      const next = new Set(s);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });

  return (
    <>
      <div className="d-flex gap-2 mb-2">
        <button
          type="button"
          className="btn btn-sm btn-light border"
          onClick={() => setOpen(new Set(allIds(nodes)))}
        >
          Expand all
        </button>
        <button
          type="button"
          className="btn btn-sm btn-light border"
          onClick={() => setOpen(new Set())}
        >
          Collapse all
        </button>
      </div>
      <ul className="org-tree">
        {nodes.map((n) => (
          <Node
            key={n.id}
            node={n}
            depth={0}
            open={open}
            toggle={toggle}
            renderNode={renderNode}
            isInactive={isInactive}
          />
        ))}
      </ul>
    </>
  );
};

export default OrgTree;
